"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var GoogleAnalytics = function () { return function (events) {
    if (typeof window === 'undefined') {
        return;
    }
    if (typeof window.ga !== 'function') {
        throw new Error('window.ga is not defined, Have you forgotten to include Google Analytics?');
    }
    events.forEach(function (event) {
        var customTrackerId = event.customTrackerId || event.tracker;
        var trackerId = !!customTrackerId && !!customTrackerId.trim()
            ? customTrackerId + "."
            : '';
        var ecommPluginType = event.ecommType === 'enhanced' ? 'ec' : 'ecommerce';
        if (utils_1.isEcommEvent(event)) {
            var callEvent = function (type) {
                return ({
                    addItem: function () {
                        return ga("" + trackerId + ecommPluginType + ":addItem", utils_1.filterEcommEvents(event));
                    },
                    addTransaction: function () {
                        return ga("" + trackerId + ecommPluginType + ":addTransaction", utils_1.filterEcommEvents(event));
                    },
                    addImpression: function () {
                        return ga("" + trackerId + ecommPluginType + ":addImpression", utils_1.filterEcommEvents(event));
                    },
                    addProduct: function () {
                        return ga("" + trackerId + ecommPluginType + ":addProduct", utils_1.filterEcommEvents(event));
                    },
                    addPromo: function () {
                        return ga("" + trackerId + ecommPluginType + ":addPromo", utils_1.filterEcommEvents(event));
                    },
                    addAction: function () {
                        return ga("" + trackerId + ecommPluginType + ":setAction", event.actionName, utils_1.filterEcommEvents(event));
                    },
                    ecommClear: function () { return ga("" + trackerId + ecommPluginType + ":clear"); },
                    ecommSend: function () { return ga("" + trackerId + ecommPluginType + ":send"); },
                }[type]());
            };
            callEvent(event.hitType);
        }
        else {
            if (event.hitType === 'pageview') {
                ga(trackerId + "set", 'page', event.page);
            }
            ga(trackerId + "send", event);
        }
    });
}; };
exports.default = GoogleAnalytics;
